export default __webpack_public_path__ + "static/media/ai-invoicing.30c8a6da.png";